export default "__VITE_ASSET__ZCWJJGy___"